{
  "info": "Informationen",
  "negative": "Fehler",
  "positive": "Erfolg"
}
